import React, {useEffect, useState} from "react";
import Header from "./components/header/Header";
import { useParams } from "react-router-dom";
import { Projects,splashScreen,infoCarusel } from "../portfolio"; 
import Profile from "../containers/profile/Profile";
import SplashScreen from "../containers/splashScreen/SplashScreen";
import {useLocalStorage} from "../hooks/useLocalStorage";
import {StyleProvider} from "../contexts/StyleContext";
import "./Project.scss";

const Project = () => {
  
  const { projectName } = useParams();
  const projectData = Projects[projectName];

  const darkPref = window.matchMedia("(prefers-color-scheme: dark)");
  const [isDark, setIsDark] = useLocalStorage("isDark", darkPref.matches);
  const [isShowingSplashAnimation, setIsShowingSplashAnimation] =
    useState(true);

  useEffect(() => {
    if (splashScreen.enabled) {
      const splashTimer = setTimeout(
        () => setIsShowingSplashAnimation(false),
        splashScreen.duration
      );
      return () => {
        clearTimeout(splashTimer);
      };
    }
  }, []);

  const changeTheme = () => {
    setIsDark(!isDark);
  };
  if (!projectData) {
    return <div>Project not found</div>;
  }

  return (
    
    <div className={isDark ? "dark-mode" : null}>
      <StyleProvider value={{isDark: isDark, changeTheme: changeTheme}}>
        {isShowingSplashAnimation && splashScreen.enabled ? (
          <SplashScreen />
        ) : (
          <>
          <Header />
          <div className="proj-bg-main">
              <div className="proj-bg-div">
                <div className="proj-bg-line"></div>
                <div className="proj-bg-line"></div>
                <div className="proj-bg-line"></div>
                <div className="proj-bg-line"></div>
                <div className="proj-bg-line-780"></div>
                <div className="proj-bg-line-780"></div>
                <div className="proj-bg-line-780"></div>
                <div className="proj-bg-line-1200"></div>
                <div className="proj-bg-line-1200"></div>
              </div>
            </div>
          <div className="proj-div-main">
            
      {projectData.map((item, index) => (
        <div key={index}>
          <div className="proj-inline-margin">
          {item.name && <p className="proj-txt-name">{item.name}</p>}
          {item.header && <h2 className="proj-txt-hdr">{item.header}</h2>}
          {item.header &&<div className="proj-div-img-hdr">  
                            <img
                                alt="Header Project"
                                src={item.images.main}
                            ></img>
                        </div>}
                      </div>
            <div className="achievement-main-div" style={{marginBlock: "60px"}}>
          <div class="slider-container-proj">
    <div class="slider-track-proj">
      {infoCarusel.infocarusel.map((info, i) => {
            return (
                <div class="button-wrapper-proj">
                  <div class="slider-shadow-box-proj"></div>
                  <div class="slider-brand-proj">
                    <p>{info.info}</p>
                  </div>
                </div>
            );
          })}
          {infoCarusel.infocarusel.map((info, i) => {
            return (
                <div class="button-wrapper-proj">
                  <div class="slider-shadow-box-proj"></div>
                  <div class="slider-brand-proj">
                    <p>{info.info}</p>
                  </div>
                </div>
            );
          })}
      
            </div>
          </div>
         </div>
          <div className="proj-inline-margin">
            <div style={{display:"flex",gap:"46px"}}>
            {item.role && 
              <div style={{width:"100%"}}>
                <p className="proj-txt-name">MY ROLE</p>
                <p className="proj-txt-role">{item.role}</p>
              </div>
            }

            {item.year && 
              <div style={{width:"100%"}}>
                <p className="proj-txt-name">YEAR</p>
                <p className="proj-txt-role">{item.year}</p>
              </div>
            }
            </div>
          </div>
          {/* Unique part */}

            <div className="aboutme-div-main" style={{marginTop:"50px"}}>
              {item.info.map((qna, index) => (
                <div key={index}>
                {qna.question &&
                  <div className="aboutme-div-story" style={{marginBottom:"20px"}} data-framer-name="Container">
                      <div className="aboutme-div-story-left" data-framer-name="Left">
                          <span data-text-fill="true" className="aboutme-txt-header-story-proj">{qna.question}</span> 
                      </div>
                      <div className="aboutme-div-story-right" data-framer-name="Right">
                          <h3 style={{margin:0}}>
                            {qna.answer}
                          </h3>
                          {qna.button &&
                            <div style={{display:"flex",gap:"20px"}}>
                              {qna.button.map((btn, index) => (
                                
                                <a href={btn.url} className="proj-btn-frame">
                                  <div style={{display:"flex",gap:"8px"}}>
                                    <img
                                      height={20}
                                      width={20}
                                      style={{marginLeft: "15px",filter: "brightness(0) invert(1)"}}
                                      src={btn.imgs}
                                    ></img>
                                    <p style={{margin:0,fontFamily:"NeueMontrealMedium",fontSize:"16px",marginRight: "15px"}}>{btn.text}</p>
                                  </div>
                                  
                                </a>
                              ))}
                            </div>
                          }
                      </div>
                  </div>
                }
                {qna.image &&
                  <div className="proj-div-img-hdr" style={{marginBottom:"46px",width:"90%",marginLeft:"5%"}}>  
                    <img
                      alt="Info Project"
                      src={qna.image}
                    ></img>
                  </div>
                }
                </div>))}
            </div>

          {/* ------- */}
        </div>
      ))}
    </div>
            <Profile />
            
            {/* <ScrollToTopButton /> */}
          </>
        )}
      </StyleProvider>
    </div>
  );
};

export default Project;
